/**
 * Shared copy for the "gender is an AI guess" disclosure.
 *
 * It lives in one place because it is shown anywhere `gender_ai` is displayed
 * (the staff directory header, the volunteers panel), and those must not drift
 * into saying different things about the same number. The value is produced by
 * backend/pipeline/predict_gender.py; `gender_self` — what a member says about
 * themselves — is a separate field and is never what this column shows.
 */
export const GENDER_AI_HELP: { title: string; body: string; items: string[] } = {
    title: "Gender is an AI estimate",
    body:
        "Predicted by the data pipeline from the member's name and location. It is not " +
        "self-reported and it can be wrong.",
    items: [
        "\"Not sure\" means the model had no confident answer, or the member has not been processed yet.",
        "Accuracy varies by naming tradition — unisex and romanised names are often left as \"Not sure\" rather than guessed.",
        "Use it for rough segmentation, never as a record of how someone identifies.",
        "If a member has told us their gender themselves, that is stored separately and takes precedence.",
    ],
};
